import SearchBar from "./Search";
import Navbar from "./Navbar"

const Home = () => {
    return (
        <div className="home">
           <Navbar />
           <SearchBar />
        </div>
    );
}
 
export default Home;